import SignatureCanvas from 'react-signature-canvas';

const validateSignature = (signatureRef: SignatureCanvas | null | undefined): boolean =>
  !!signatureRef && !signatureRef.isEmpty();

export default validateSignature;
